import { render } from "./InsertPackage.vue?vue&type=template&id=0364ea7a&scoped=true"
import script from "./InsertPackage.vue?vue&type=script&lang=js"
export * from "./InsertPackage.vue?vue&type=script&lang=js"

import "./InsertPackage.vue?vue&type=style&index=0&id=0364ea7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0364ea7a"]])

export default __exports__